(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinieco-home"]) return;
  try {
    
document.addEventListener("DOMContentLoaded",function(){
  var e=document.querySelector(".header-logo__image");
  if(e&&!e.src.includes("v2")){
    e.src=e.src.replace("clinieco-logo_600x.png","clinieco-logo-v2.png");
    e.style.width="auto";
    e.style.height="36px";
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
